module.exports = __webpack_public_path__ + "img/red-marker-icon-2x.e572ac7c.png";